var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkBlack = function SvgLinkBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "#00263E",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.094 16.094a3.32 3.32 0 0 1-4.688 0c-.315-.315-.416-.724-.101-1.04a.807.807 0 0 1 1.14 0l-.101.102a1.97 1.97 0 0 0 2.813 0l3.437-3.438a1.97 1.97 0 0 0 0-2.812 1.97 1.97 0 0 0-2.812 0L14.5 12.187a.663.663 0 1 1-.95-.924l.012-.014 3.282-3.281a3.32 3.32 0 0 1 4.688 0 3.32 3.32 0 0 1 0 4.688zm-5.938 5.938a3.32 3.32 0 0 1-4.688 0 3.32 3.32 0 0 1 0-4.688l3.438-3.438a3.323 3.323 0 0 1 4.688 0c.36.063.576.552.513.912a.663.663 0 0 1-.767.54c-.275-.049-.49-.264-.684-.514a1.97 1.97 0 0 0-2.813 0l-3.438 3.438a1.97 1.97 0 0 0 0 2.813 1.97 1.97 0 0 0 2.813 0l3.282-3.282a.663.663 0 0 1 .95.926l-.012.011z"
  }))));
};
export default SvgLinkBlack;